const LoadingComponent = () => {
  return (
    <div
      role="status"
      className="flex justify-center w-full animate-pulse py-12"
    >
      <div className="flex flex-col w-[400px]">
        <div className="h-8 bg-gray-200 rounded w-1/4 mb-8"></div>
        <div className="h-12 bg-gray-200 rounded mb-8"></div>
        <div className="h-22 bg-gray-200 rounded mb-8"></div>
        <div className="h-16 bg-gray-200 rounded mb-4"></div>
        <span className="sr-only">Loading...</span>
      </div>
    </div>
  );
};

export default LoadingComponent;
